<template>
  <div :class="'side '+show">
    <el-button v-if="!is_show" @click="hide()" plain type="text" :class="'side-header-view view-color '+show" >OPEN</el-button>
    <el-menu v-if="is_show" mode="vertical" :default-active="$route.path" class="side" background-color='#ffffff00' text-color="#859da9" active-text-color="#5151db" unique-opened router>
        <div class="menu-logo">
          <img src="../assets/logo_rectangle.png" style="width:200px;" />
        </div>
        <div class="header-img" v-if="user_name === 'green'">
          <img src="../assets/header/green.jpg" style="width:100%;" />
        </div>
        <div class="user-info-view">
          <el-button @click="hide()" plain type="text" class="side-header-view" icon="el-icon-view" />
          <user-info/>
        </div>
        <div class="menu-items">
            <mm-menu-item title="Advertiser" menu-class="el-icon-s-custom" index="/advList"/>
            <mm-menu-item title="Channel" menu-class="el-icon-user-solid" index="/channelList"/>
            <el-submenu index="offer" v-if="!is_finance">
              <span class="el-icon-s-order" slot="title">&nbsp;Offer</span>
              <mm-menu-item title="Offer List" index="/offerList" />
              <mm-menu-item title="Campaign List" index="/campList"/>
              <!-- <mm-menu-item title="Top Offer List" index="/topOffer" /> -->
              <mm-menu-item title="mmp Offer List" index="/mmpOfferList" />
              <mm-menu-item title="mmp Campaign List" index="/mmpCampList"/>
            </el-submenu>
            <mm-menu-item index="/report" menu-class="el-icon-s-data" title=" Report"  v-if="!is_finance"/>
            <!-- <mm-menu-item index="/datanalyze" menu-class="el-icon-zoom-in" title=" Datanalyze"/> -->
            <el-submenu index="finance">
              <span class="el-icon-data-line" slot="title">&nbsp;Finance</span>
              <mm-menu-item title="AdvSummary List" index="/advSummaryList" v-show="is_show_advSummary"/>
              <mm-menu-item title="AdvOffer List" index="/advOfferList" v-show="is_show_advSummary"/>
              <mm-menu-item title="ChannelSummary List" index="/channelSummaryList" v-show="is_show_channelSummary"/>
              <mm-menu-item title="ChannelOffer List" index="/channelOfferList" v-show="is_show_channelSummary"/>
              <el-submenu index="mmpFinance">
                <span class="el-icon-data-line" slot="title">&nbsp;Mmp</span>
                <mm-menu-item title="AdvSummary List" index="/advMmpSummaryList" v-show="is_show_advSummary"/>
                <mm-menu-item title="AdvOffer List" index="/advMmpOfferList" v-show="is_show_advSummary"/>
                <mm-menu-item title="ChannelSummary List" index="/channelMmpSummaryList" v-show="is_show_channelSummary"/>
                <mm-menu-item title="ChannelOffer List" index="/channelMmpOfferList" v-show="is_show_channelSummary"/>
              </el-submenu>
            </el-submenu>
            <el-submenu index="riskIP"  v-if="!is_finance">
            <span class="el-icon-location" slot="title">&nbsp;Risk IP</span>
            <mm-menu-item title="IP Black List" index="/blackIpList"/>
            <mm-menu-item title="TOP Ip" index="/topIP"/>
          </el-submenu>
            <el-submenu index="Log"  v-if="!is_finance">
            <span class="el-icon-notebook-2" slot="title">&nbsp;Log</span>
            <mm-menu-item title="Offer Status Log" index="/offerStatusLog"/>
            <mm-menu-item title="Offer Trace Log" index="/offerTraceLog"/>
            <mm-menu-item title="Event Log" index="/eventLog"/>
            <mm-menu-item title="Conver Time Log" index="/converTimeLog"/>
            <mm-menu-item title="Imp Log" index="/impLog"/>
          </el-submenu>
          <el-submenu index="setting" v-show="is_show_setting">
            <span class="el-icon-s-tools" slot="title">&nbsp;Setting</span>
            <mm-menu-item title="user" index="/user"/>
          </el-submenu>
          <el-submenu index="tools"  v-if="!is_finance">
            <span class="el-icon-s-cooperation" slot="title">&nbsp;Tools</span>
            <mm-menu-item title="Postback" index="/postback"/>
            <mm-menu-item title="CountryCode" index="/countrycode"/>
            <mm-menu-item title="Subid Transform" index="/subidTransform"/>
            <mm-menu-item title="Subid Transform Fafa" index="/subidTransformOld"/>
            <mm-menu-item title="Dict List" index="/dictList"/>
            <mm-menu-item title="URL Jump" index="/urlJump"/>
            <mm-menu-item title="AF Event Log" index="/afEventLog"/>
            <mm-menu-item title="AF Code" index="/afCode"/>
            <mm-menu-item title="Set Otpauth Migration" index="/setOtpauthMigrationToDict"/>
            <!-- <mm-menu-item title="Domains" index="/domains"/> -->
          </el-submenu>
          <el-button v-if="hide_button" @click="hide()" plain class="side-footer-view">
            HIDE
          </el-button>
        </div>
        </el-menu>

  </div>
</template>

<script>
export default {
	data() {
		const hide_button = this.$cache.browse_model === 'phone' ? true : false;
    const user_info = this.$utils.getCookies(['user_name','group_name','is_super']);
    const is_show_setting = (user_info.group_name === 'admin'&&user_info.is_super=='1');
    const is_show_advSummary = ['admin','am','finance'].includes(user_info.group_name);
    const is_show_channelSummary = ['admin','pm','finance'].includes(user_info.group_name);
    const is_finance = ['finance'].includes(user_info.group_name);
		return {
			hide_button: hide_button,
			show: 'side-show',
			is_show: true,
      is_show_setting,
      is_show_advSummary,
      is_show_channelSummary,
      is_finance,
      user_name: user_info.user_name,
		}
	},
	methods: {
		hide() {
			if (this.show === 'side-show') {
				this.is_show = false;
				this.show = 'side-hide';
			} else {
				this.is_show = true;
				this.show = 'side-show';
			}
		}
	},
}
</script>
<style scoped>
.side {
	height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.side-show {
	width: 250px;
}
.side-hide {
  width: 50px;
}
.side-header-view {
  color: #5151db;
}
.side-footer-view {
  margin-left: 15px;
  width: 150px;
  height: 150px;
  background: #ffffff;
  color: rgb(0, 0, 0);
}
.view-color {
  height: 100%;
  background: #fff;
  color: mediumslateblue;
}
.user-info-view {
  display: flex;
  justify-content: center;
}
.menu-logo {
  width: 94%;
  height: 100px;
  padding: 3%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.header-img {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.menu-items {
  flex: 1;
  width: 220px;
  overflow-y: auto;
}
</style>
